import BubbleChartImages from './BubbleChartImages';

export default BubbleChartImages;
